import React from 'react';
import { User, Car, Clock, Wrench, Timer } from 'lucide-react';
import { Card } from '@/components/ui/card';

export const ClientVehicleInfo = ({ client, vehicle, appointment, timeSummary, isAtelier }) => {
  return (
    <>
      <div className="grid md:grid-cols-2 gap-4">
        <Card className="p-4 rounded-xl space-y-2">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2"><User className="w-4 h-4" /> Client</h3>
          {client ? (
            <div className="text-sm space-y-1">
              <p className="font-medium">{client.first_name} {client.last_name}</p>
              {client.phone && <p className="text-slate-500">{client.phone}</p>}
              {client.email && <p className="text-slate-500">{client.email}</p>}
              {client.address && <p className="text-slate-500">{client.address}</p>}
              {client.notification_preference && client.notification_preference !== 'none' && (
                <p className={`text-xs font-medium px-2 py-0.5 rounded-full inline-block mt-1 ${
                  client.notification_preference === 'whatsapp' ? 'bg-green-100 text-green-700' :
                  client.notification_preference === 'email' ? 'bg-blue-100 text-blue-700' :
                  client.notification_preference === 'phone' ? 'bg-amber-100 text-amber-700' :
                  client.notification_preference === 'both' ? 'bg-purple-100 text-purple-700' :
                  'bg-slate-100 text-slate-600'
                }`} data-testid="wo-client-pref">
                  {client.notification_preference === 'whatsapp' ? 'WhatsApp' :
                   client.notification_preference === 'email' ? 'Email' :
                   client.notification_preference === 'phone' ? 'Tel. uniquement' :
                   client.notification_preference === 'both' ? 'WhatsApp + Email' : client.notification_preference}
                </p>
              )}
            </div>
          ) : <p className="text-sm text-slate-400">-</p>}
        </Card>
        <Card className="p-4 rounded-xl space-y-2">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2"><Car className="w-4 h-4" /> Véhicule</h3>
          {vehicle ? (
            <div className="text-sm space-y-1">
              <p className="font-medium">{vehicle.brand} {vehicle.model}</p>
              <p className="text-slate-500">Plaque: {vehicle.plate}</p>
              {vehicle.mileage > 0 && <p className="text-slate-500">Km: {vehicle.mileage.toLocaleString()}</p>}
              {vehicle.vin && <p className="text-slate-500">VIN: {vehicle.vin}</p>}
            </div>
          ) : <p className="text-sm text-slate-400">-</p>}
        </Card>
      </div>

      {appointment && (
        <Card className="p-4 rounded-xl">
          <div className="flex flex-wrap gap-4 text-sm">
            <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-slate-400" /><span>{appointment.date} a {appointment.time}</span></div>
            {appointment.drop_off_time && <div className="flex items-center gap-2"><Clock className="w-4 h-4 text-slate-400" /><span>Dépôt : {appointment.drop_off_time}</span></div>}
            {(appointment.pickup_date || appointment.pickup_time) && (
              <div className="flex items-center gap-2">
                <Clock className="w-4 h-4 text-emerald-500" />
                <span className="text-emerald-700 font-medium">
                  Reprise : {appointment.pickup_date ? new Date(appointment.pickup_date).toLocaleDateString('fr-CH') : ''}{appointment.pickup_date && appointment.pickup_time ? ' a ' : ''}{appointment.pickup_time || ''}
                </span>
              </div>
            )}
            <div className="flex items-center gap-2"><Wrench className="w-4 h-4 text-slate-400" /><span>{appointment.category?.toUpperCase()}{appointment.intervention_type ? ` - ${appointment.intervention_type}` : ''}</span></div>
            {appointment.insurance_number && <div className="flex items-center gap-2"><span>Sinistre: {appointment.insurance_number}</span></div>}
          </div>
        </Card>
      )}

      {timeSummary && timeSummary.total_minutes > 0 && (
        <Card className="p-4 rounded-xl space-y-3" data-testid="work-time-summary">
          <h3 className="text-sm font-bold text-slate-900 flex items-center gap-2">
            <Timer className="w-4 h-4" /> Heures travaillees
            <span className="ml-auto text-lg font-bold text-blue-600" data-testid="total-hours">
              {Math.floor(timeSummary.total_minutes / 60)}h{String(timeSummary.total_minutes % 60).padStart(2, '0')}
            </span>
          </h3>
          <div className="space-y-1.5">
            {timeSummary.employees.map(emp => {
              const h = Math.floor(emp.total_minutes / 60);
              const m = emp.total_minutes % 60;
              return (
                <div key={emp.employee_id} className="flex items-center justify-between text-sm bg-slate-50 rounded-lg px-3 py-2">
                  <span className="font-medium text-slate-700">{emp.name}</span>
                  <span className="font-mono text-slate-900 font-bold">{h}h{String(m).padStart(2, '0')}</span>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </>
  );
};
